import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { EmbedFormBtn } from "./embedFormButtons";

/**
 * Bootstrap confirm dialog for embed-forms UI (replaces react-confirm-alert here).
 */
export default function EmbedFormConfirmModal({
    show,
    onHide,
    title,
    message,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    onConfirm,
    confirmVariant = EmbedFormBtn.danger,
    cancelVariant = EmbedFormBtn.neutral,
    centered = true,
    backdrop = true,
    keyboard = true,
    closeButton = true,
    closeOnConfirm = true,
}) {
    const [busy, setBusy] = useState(false);

    const handleConfirm = async () => {
        if (busy) {
            return;
        }
        setBusy(true);
        try {
            await Promise.resolve(onConfirm?.());
            if (closeOnConfirm) {
                onHide();
            }
        } finally {
            setBusy(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered={centered}
            backdrop={backdrop}
            keyboard={keyboard}
            className="embed-forms-ui"
        >
            <Modal.Header closeButton={closeButton}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <Button
                    type="button"
                    variant={cancelVariant}
                    onClick={onHide}
                    disabled={busy}
                >
                    {cancelLabel}
                </Button>
                <Button
                    type="button"
                    variant={confirmVariant}
                    onClick={handleConfirm}
                    disabled={busy}
                >
                    {confirmLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
